module.exports = __webpack_public_path__ + "img/label.f53ca30c.jpg";